import axios from 'axios';
import Metadata from '../helpers/metadata/Metadata';
import serviceUtil from './serviceUtil';

function createSupportRequest(supportRequest, eventMetadatum, options) {
  if (!eventMetadatum) {
    eventMetadatum = Metadata.generateMetadatum();
  }
  let tokenHeader = localStorage.token ? { 'Authorization': 'Token token=' + localStorage.token } : { };

  const formData = new FormData();
  Object.keys(supportRequest).map(key => {
    if(key == 'attachment' && supportRequest.attachment){
      supportRequest.attachment.forEach(attachment=>{
        formData.append('support_request[attachment][]', attachment['upload']);
      });
    }else{
      formData.append(`support_request[${key}]`, supportRequest[key]);
    }
  });
  formData.append('event_metadatum', JSON.stringify(eventMetadatum));
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API + '/support_requests',
    data: formData,
    headers: {
      'Content-Type': 'application/json',
      tokenHeader,
    },
  })
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return serviceUtil.resultForError(error);
  });
}

export default {
  createSupportRequest,
};



// WEBPACK FOOTER //
// ./src/services/supportRequestsService.js